import Vue from 'vue';
export const PageEventBus = new Vue();
export default PageEventBus;

